import React from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import i18n from '../i18n'
import ContactComponent from '../partials/Contact'

export default function Contact() {
	const { t } = useTranslation();

	return (
		<main id="main" className="pt-32">
            <Helmet>
                <title>{t('menu.contact')} - {process.env.REACT_APP_NAME}</title>
            </Helmet>
			<ContactComponent />
		</main>
	);
}
